module.exports = __webpack_public_path__ + "media/icons/add-cookie-script-ad1db81f.svg";